import styled, {keyframes} from 'styled-components'

const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`

const SpinnerContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 20px;
`

const Spinner = styled.div`
	width: ${(props) => props.size || '40px'};
	height: ${(props) => props.size || '40px'};
	border: 4px solid #f3f3f3;
	border-top: 4px solid ${(props) => props.color || '#3498db'};
	border-radius: 50%;
	animation: ${spin} 1s linear infinite;
`

const LoadingText = styled.p`
	margin-left: 12px;
	color: ${(props) => props.textColor || '#666'};
	font-size: 14px;
`

/**
 * @Desc 기본 스핀 로딩 컴포넌트
 * @param {string} size - 스피너 크기 (기본값: '40px')
 * @param {string} color - 스피너 색상 (기본값: '#3498db')
 * @param {string} textColor - 텍스트 색상 (기본값: '#666')
 * @param {string} text - 로딩 텍스트 (선택사항)
 * @param {boolean} showText - 텍스트 표시 여부 (기본값: false)
 */
const DefaultSpinLoading = ({
	size = '40px',
	color = '#3498db',
	textColor = '#666',
	text = '로딩 중...',
	showText = false,
}) => {
	return (
		<SpinnerContainer>
			<Spinner size={size} color={color} />
			{showText && <LoadingText textColor={textColor}>{text}</LoadingText>}
		</SpinnerContainer>
	)
}

export default DefaultSpinLoading
